import { TYPE_STRING } from './input-types';

export const id = 'batchNumber';
export const apiKey = 'BatchNumber';
export const type = TYPE_STRING;

export const batchNumber = {
  id,
  apiKey,
  type,
};
